export default __webpack_public_path__ + "91e8f388aee9c6c69e3f596ce26b1f41.png";